import React, { FC } from 'react';
import './Loader.scss';

const Loader: FC = () => <div className="loader" />;
export default Loader;
